'use strict';

var colors = {
    white: '#ffffff',
    turquoise100: '#5f8b80',
    turquoise90: '#8EC5B7',
    turquoise80: '#8EC5B7',
    turquoise70: '#8EC5B7',
    turquoise60: '#8EC5B7',
    turquoise50: '#D1E8E3',
    turquoise40: '#D1E8E3',
    turquoise30: '#D1E8E3',
    turquoise20: '#D1E8E3',
    turquoise10: '#D1E8E3',
    red100: '#F24F2B',
    red90: '#F24F2B',
    red80: '#F24F2B',
    red70: '#F24F2B',
    red60: '#F49C9C',
    red50: '#F49C9C',
    red40: '#F49C9C',
    red30: '#FDEBEB',
    red20: '#FDEBEB',
    red10: '#FDEBEB',
    charcoal100: '#1D1D1F',
    charcoal90: '#1D1D1F',
    charcoal80: '#565657',
    charcoal70: '#565657',
    charcoal60: '#8D8D8E',
    charcoal50: '#8D8D8E',
    charcoal40: '#8D8D8E',
    charcoal30: '#C6C6C7',
    charcoal20: '#C6C6C7',
    charcoal20New: '#F3F3F4',
    charcoal10: '#F3F3F4',
    ivorey: '#F9F8F6',
    charcoal3: '#F9F8F6',
    charcoal2: '#F9F8F6',
    yellow100: '#FFA800',
    yellow90: '#FFA800',
    yellow80: '#FFA800',
    yellow70: '#FFA800',
    yellow60: '#FFD380',
    yellow50: '#FFD380',
    yellow40: '#FFD380',
    yellow30: '#FFF6E6',
    yellow20: '#FFF6E6',
    yellow10: '#FFF6E6',
    green100: '#42A775',
    green80: '#42A775',
    green50: '#A0D3BA',
    green30: '#ECF6F1',
    green10: '#ECF6F1',
    facebook01: '#4267B2',
    skeleton01: 'rgba(0,0,0,0.025)',
    skeleton02: 'rgba(0,0,0,0.3)',
    iconSuccess: '#42A775',
    iconWarning: '#FFA800',
    iconCritical: '#F24F2B',
    borderSuccess: '#A0D3BA',
    borderWarning: '#FFD380',
    borderCritical: '#F49C9C',
    borderTurquoise: '#D1E8E3',
    borderCharcoal: '#C6C6C7',
    surfaceSuccess: '#ECF6F1',
    surfaceWarning: '#FFF6E6',
    surfaceCritical: '#FDEBEB',
    surfaceTurquoise: '#D1E8E3',
    surfaceCharcoal: '#F9F8F6',
    flagsGreen: '#42A775',
    flagsYellow: '#FFA800',
    flagsRed: '#F24F2B',
    flagsBlue: '#006699',
    clubBarBannerGradientStart: '#E0AF91',
    clubBarBannerGradientEnd: '#E7A96A',
    component: {
        get productTileSurface() {
            return '#F9F8F6';
        },
    },
};

exports.colors = colors;
//# sourceMappingURL=colors-21547aad.js.map
